<template><!-- svgo-optimised -->
<svg class="icon icon__arrow icon__arrow--down" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12 14-3-3.5h6L12 14Z"/></svg>
</template>